import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://caxjqyvyiedfrhdrcgls.supabase.co';
const supabaseKey = 'sb_publishable_ySOLkSWknpWpurJMO3I5Gw_ncgpA6ZK';

export const supabase = createClient(supabaseUrl, supabaseKey);
